export default {
  computed: {
    isUserReadOnly() {
      return this.currentUser.role == 'user' && this.currentUser.read_only
    },
  }
}
